import React, { useEffect, useState } from "react";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import { ToastContainer } from "react-toastify";
import List from "../../../components/List/List";
import Loader from "../../../components/Loader/Loader";

const RoutinePeriodList = () => {
  const headers = ["Effective From", "Effective To", "Enrollment"];
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await adminRequest.get(`${BASE_URL}/routinePeriod/list`);
      const fetchedRows = response.data.data.map((e) => ({
        displayData: [
          e.effectiveFrom,
          e.effectiveTo,
          e.enrollmentSetup.enrollmentBatch,
        ],
        uuid: e.uuid,
      }));
      setRows(fetchedRows);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const getMenuItems = (row) => [{ link: `edit/${row.uuid}`, text: "Edit" }];
  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <List
            title="Routine Period List"
            createButtonLabel="Create Routine Period"
            headers={headers}
            rows={rows.map((row) => row.displayData)}
            link="create"
            showEyeViewIcon={false}
            showFilterIcon={false}
            getMenuItems={(row) =>
              getMenuItems(rows.find((r) => r.displayData === row))
            }
          />
        </>
      )}
      <ToastContainer position="top-center" />
    </div>
  );
};

export default RoutinePeriodList;
